/**
 * @format
 */

import {AppRegistry} from 'react-native';
import App from './App.web';

AppRegistry.registerComponent('rn-web', () => App);
AppRegistry.runApplication('rn-web', {
  initialProps: {},
  rootTag: document.getElementById('root'),
});
